import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

const interestPreviewSerializeMap: SerializeMap<InterestPreviewData> = {
  id: "id",
  billingDocumentId: "billing_document_id",
  businessId: "business_id",
  interestRate: "interest_rate",
  interestToChargeCents: "interest_to_charge_cents",
  daysOfInterest: "days_of_interest",
  chargeFromDate: "charge_from_date",
  chargeToDate: "charge_to_date",
};

export const deserializeInterestPreview = buildDeserializer(
  interestPreviewSerializeMap,
  "interest preview",
);

export const serializeInterestPreview = buildSerializer(
  interestPreviewSerializeMap,
  "interest preview",
);
